var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { Decoration_Type } from "./../../ricos-schema/legacy/wix/rich_content/v1";
class EmptyDecoration {
  constructor() {
    __publicField(this, "type", Decoration_Type.UNRECOGNIZED);
  }
  getDecoration() {
    return {};
  }
  fromCustomStyle(_customStyle) {
    return new EmptyDecoration();
  }
  toCustomStyle() {
    return {};
  }
  overrideWith(decoration) {
    return decoration;
  }
}
export {
  EmptyDecoration
};
//# sourceMappingURL=empty-decoration.js.map
